import window from 'window-or-global';
import { exportAjsRteAsGlobal } from '@confluence-classic/confluence-editor/src/global-objects/ajs-rte';
import { exportAjsRteBootstrapManagerAsGlobal } from '@confluence-classic/confluence-editor/src/global-objects/ajs-rte-bootstrapmanager';

export function getBootstrapManager() {
	exportAjsRteAsGlobal();
	exportAjsRteBootstrapManagerAsGlobal();
	return window.AJS.Rte.BootstrapManager;
}

export function getRte() {
	exportAjsRteAsGlobal();
	return window.AJS.Rte;
}

export function getAutocompleter() {
	return window.Confluence.Editor.Autocompleter;
}
